module.exports = __webpack_public_path__ + "media/images/home/hero-poster-desktop-f5fd06deaaecc80fad58a506e40dcbcd.jpg";